import React, { useContext, useState } from "react";
import cx from "classnames";
import { FocusPageBenefits } from "components/FocusPageBenefits";
import { FocusPageFocusFor } from "components/FocusPageFocusFor";
import { FocusPageHeroBanner } from "components/FocusPageHeroBanner";
import { ProductSlider } from "components/ProductSlider";
import RockstarFooter from "components/RockstarFooter";
import RockstarHeader from "components/RockstarHeader";
import { Ticker } from "components/Ticker";
import TopCtaBanner from "components/TopCtaBanner";
import { FaqType, Faqs } from "components/Faqs";
import st from "./index.module.scss";
import { LogContext } from "context/log";
import { PAGE_TYPE_ENUM } from "@pepdirect/shared/types";
import { generatePageId } from "@pepdirect/helpers/analyticsLogger";
import { FocusPagePhotography } from "components/FocusPagePhotography";

const faqs: FaqType[] = [
  {
    question: "B-Vitamins",
    answer: (
      <div className={st.faqAnswer}>
        B-group vitamins are essential nutrients that contribute to normal
        energy metabolism.
      </div>
    ),
  },
  {
    question: "Lion’s Mane",
    answer: (
      <div className={st.faqAnswer}>
        Lion’s Mane is a mushroom with a long history of use in Eastern
        cultures. Lion’s Mane mushroom extract is a concentrated form of Lion’s
        Mane.
      </div>
    ),
  },
  {
    question: "Taurine",
    answer: (
      <div className={st.faqAnswer}>
        Taurine is an amino acid commonly found in meat, poultry, eggs, dairy
        products, and fish.
      </div>
    ),
  },
  {
    question: "Guarana",
    answer: (
      <div className={st.faqAnswer}>
        Guarana Seed Extract is a source of caffeine. It is derived from the
        seeds of the species Paullinia Cupana.
      </div>
    ),
  },
  {
    question: "Milk Thistle",
    answer: (
      <div className={st.faqAnswer}>
        Milk thistle is an herb of the species Silybum marianum. Milk thistle
        extract is derived from milk thistle.
      </div>
    ),
  },
];

export default function Focus() {
  const { useLogPageView } = useContext(LogContext);
  const [faqSelected, setFaqSelected] = useState<number>(0);

  useLogPageView({
    pageType: PAGE_TYPE_ENUM.marketing,
    pageCategory: undefined,
    pageTitle: "focus landing",
    id: generatePageId("focus landing"),
  });

  return (
    <>
      <div id="page" className="site">
        <div className="site-header-block">
          <TopCtaBanner />
          <RockstarHeader />
        </div>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main" role="main">
              <article
                id="post-39"
                className="post-39 page type-page status-publish hentry entry"
              >
                <div className={cx("entry-content", st.container)}>
                  <FocusPageHeroBanner />
                  <Ticker isGreenBackground />
                  <ProductSlider />
                  <FocusPageFocusFor />
                  <FocusPagePhotography />
                  <Ticker />
                  <FocusPageBenefits />
                  <div className={st.faqContainer}>
                    <div className={st.faqContent}>
                      <h2 className={st.faqHeading}>
                        Get to know the ingredients
                      </h2>
                      <Faqs
                        onFaqClick={(idx: number) =>
                          faqSelected === idx
                            ? setFaqSelected(-1)
                            : setFaqSelected(idx)
                        }
                        selectedFaq={faqSelected}
                        faqs={faqs}
                      />
                    </div>
                  </div>
                </div>
              </article>
            </main>
          </div>
        </div>
        <RockstarFooter />
      </div>
    </>
  );
}
